import { useParams } from 'react-router-dom';
import ProfileNav from "../../app_structure/tabs_nav/ProfileNav.jsx";
import Orders_new from './orders_new.jsx';
import History from './history.jsx';

function Home() {
  const { slug_2 } = useParams();
  return (
    <>
      <div className='text-center'>
        <div className='inline-block  border-gray-200 text-center font-medium text-gray-500 bg-slate-100 mt-2 py-1 px-2 rounded-xl'>
          <ProfileNav category="phone_sms" slug_1={slug_2} />
        </div>  </div>
      {slug_2 === "orders" && (
        <>
          <Orders_new />
        </>
      )}
      {slug_2 === "history" && (
        <>
          <History />
        </>
      )}
      <br></br> <br></br>
    </>
  )
}
export default Home
